import React, { Component } from "react";
/* Bootstrap Components */
import Row from "react-bootstrap/Row";

import Col from "react-bootstrap/Col";
import { Container } from "react-bootstrap";

export default class SimpleSlider extends Component {
  render() {
    return (
      <Container fluid={true}>
        <Row style={{ marginTop: "100px" }} id="nuestros-asociados">
          <Col lg={12}>
            <img
              src="https://storage.googleapis.com/pj-chequeado-publico/landings/latamchequea/2022/logos-organizadores.jpg"
              className="img-fluid" alt="organizadores"
            />
          </Col>
        </Row>
      </Container>
    );
  }
}
